module.exports = __webpack_public_path__ + "9d2bc954cc472ba8eba5591a433f4f48.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/icons/favicon-16.png
 ** module id = 609
 ** module chunks = 0
 **/